// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1LL3r","inner":"styles_inner__1lRv7","right":"styles_right__1vsqB","close":"styles_close__1q7cA","footer":"styles_footer__25ydT"};